import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

// redirect to home and preserve query params
export const catchAllRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);

  return router.createUrlTree(['/'], {
    queryParams: route.queryParams,
  });
};
